import { createActions } from '@manager-base/app-base/config/data-access';
import { BASE_PATH_API } from '@manager-base/app-base/environment/paths/constants';

const RESOURCE = `${BASE_PATH_API}/settings/applicationBranding`;

const actions = {
    getLogo: {
        method: 'GET',
        url: `${RESOURCE}/:brandingSection/logo`
    },
    saveLogo: {
        method: 'POST',
        url: `${RESOURCE}/:brandingSection/logo`
    },
    updateLogoToUseExisting: {
        method: 'PUT',
        url: `${RESOURCE}/:brandingSection/logo`
    },
    deleteLogo: {
        method: 'DELETE',
        url: `${RESOURCE}/:brandingSection/logo`
    },
    saveText: {
        method: 'POST',
        url: `${RESOURCE}/text`
    },
    toggleProfilePhotos: {
        method: 'PUT',
        url: `${RESOURCE}/profilePhotos`
    }
};

export function ApplicationBrandingApi() {
    return createActions(actions);
}
